export const ActionTypes = {
    ChooseFile: "ChooseFile",
    Login: "Login",
    Logout: "Logout",
    CheckIFrame: "CheckIFrame",
    UpdateDesignPosition: "UpdateDesignPosition",
    UpdateTemplateSelected: "UpdateTemplateSelected",
};
